import { COLORS, LAYOUT, TYPOGRAPHY } from '../../constants';

export const styles = {
  // Page container with gradient background
  pageContainer: {
    minHeight: '100vh',
    background: `linear-gradient(135deg, ${COLORS.primary}08 0%, ${COLORS.primary}02 100%)`,
    paddingTop: LAYOUT.spacing.xl,
    paddingBottom: LAYOUT.spacing.xxxl
  },

  // Main container
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: `0 ${LAYOUT.spacing.xl}px`
  },

  // Header with icon
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.lg,
    marginBottom: LAYOUT.spacing.xxxl,
    padding: LAYOUT.spacing.xl,
    background: 'linear-gradient(135deg, #CE1126 0%, #9d0d1d 100%)',
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(206, 17, 38, 0.2)',
    color: '#fff'
  },

  headerIcon: {
    width: 64,
    height: 64,
    background: 'rgba(255, 255, 255, 0.15)',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },

  title: {
    ...TYPOGRAPHY.heading1,
    color: '#fff',
    fontWeight: 700,
    fontSize: 36,
    margin: 0,
    lineHeight: 1.2
  },

  subtitle: {
    ...TYPOGRAPHY.body,
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: 16,
    margin: `${LAYOUT.spacing.xs}px 0 0 0`,
    fontWeight: 400
  },

  // Calendar section
  calendarSection: {
    marginBottom: LAYOUT.spacing.xl,
    background: '#fff',
    borderRadius: 16,
    padding: LAYOUT.spacing.xl,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)'
  },

  // Events section
  eventsSection: {
    marginTop: LAYOUT.spacing.xl
  },

  eventsTitle: {
    ...TYPOGRAPHY.heading2,
    color: COLORS.primary,
    fontSize: 24,
    fontWeight: 700,
    marginBottom: LAYOUT.spacing.lg,
    display: 'flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.sm
  },

  // Loading and empty states
  loadingText: {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    textAlign: 'center',
    padding: LAYOUT.spacing.xl
  },

  emptyText: {
    ...TYPOGRAPHY.body,
    color: COLORS.text.muted,
    fontSize: 16,
    textAlign: 'center',
    padding: LAYOUT.spacing.xl
  }
};